export class LogoutMessage {
  constructor(public successfull: boolean) {
  }
}
